import { render, staticRenderFns } from "./Integracoes.vue?vue&type=template&id=fc2bcd1e&scoped=true"
import script from "./Integracoes.vue?vue&type=script&lang=js"
export * from "./Integracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2bcd1e",
  null
  
)

export default component.exports